module.exports = __webpack_public_path__ + "img/viber.7b258ae8.svg";